module.exports = __webpack_public_path__ + "static/media/logout.6c70a3cd.svg";